export enum TypeComponentFieldEnum {
  HIDDEN = 'hidden',
  CHECKBOX = 'checkbox',
  RADIO_BUTTON = 'radioButton',
  SLIDE_TOGGLE = 'slideToggle',
  IMAGE = 'image',
  SELECT_CRUD = 'selectCrud',
  SELECT = 'select',
  SELECT_ADVANCED_SEARCH = 'selectAdvancedSearch',
  INPUT = 'input',
  INPUT_NUMBER = 'inputNumber',
  INPUT_PHONE = 'inputPhone',
  INPUT_EMAIL = 'inputEmail',
  INPUT_CURRENCY = 'inputCurrency',
  OBJECT = 'object',
  CANCEL_SAVE = 'cancelSave',
  BUTTON = 'button',
  INPUT_PERCENT = 'inputPercent',
  SELECT_CRUD_MULTI_SELECT = 'selectCrudMultiSelect',
  INPUT_DATE = 'inputDate',
  INPUT_DATETIME = 'inputDateTime',
  DATE_RANGE = 'dateRange',
  INPUT_TEXT_AREA = "inputTextArea",
  SELECT_SEARCH = "selectSearch",
  INPUT_CNPJ = "inputCnpj",
  INPUT_CPF = "inputCpf",
  INPUT_TEXT_NUMBER = "inputTextNumber",
  INPUT_ZIP_CODE = "inputZipCode",
  INPUT_CEP = "inputCep",
  INPUT_CELLPHONE = "inputCellPhone",
  INPUT_CELLPHONE_AREA_CODE = "inputCellPhoneAreaCode",
  IMAGE_BUTTON = "imageButton",
  INPUT_FILE = "inputFile",
  INPUT_FILE_WITH_COMMENT = "inputFileWithComment",
  INPUT_FILE_WITH_COMMENT_AND_DATE = "inputFileWithCommentAndDate",
  INPUT_COLOR = "inputColor",
  INPUT_MONTH_YEAR  = "inputMonthYear",
  INPUT_CPF_AND_CNPJ = "inputCpfAndCnpj"
}
